import { useAuth } from '../../contexts/AuthContext';
import { useChat } from '../../contexts/ChatContext';

// "Contacto": abre el chat directo en modo atención al cliente.
// Logueado → inicia el handoff (el input pasa a rutear a soporte). Visitante
// → muestra el form de captura (nombre + email + mensaje) que después llama
// a startHandoff con esos datos.
const useContacto = () => {
  const { user } = useAuth();
  const { openChat, startHandoff, requestHandoffCapture } = useChat();

  return () => {
    openChat();
    if (user) {
      void startHandoff('');
    } else {
      requestHandoffCapture();
    }
  };
};

export default useContacto;
